// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_t0-0";
export var checkoutRateBadgeLink = "_t0-1";